import { useState, useCallback } from 'react';
import { pwj220Api } from '../../../services/pwj220Api';

export function usePWJ220Navigation() {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState<number>(-1);

  const fetchList = useCallback(async (keyword?: string) => {
    try {
      const res = await pwj220Api.list(1, 200, keyword);
      const ids = (res.data || []).map((r) => r.fj750_01);
      setAllIds(ids);
      return ids;
    } catch {
      return [];
    }
  }, []);

  const setCurrentById = useCallback(
    (id: string) => {
      const idx = allIds.indexOf(id);
      if (idx >= 0) setCurrentIdx(idx);
    },
    [allIds]
  );

  const goFirst = useCallback(() => {
    if (allIds.length === 0) return null;
    setCurrentIdx(0);
    return allIds[0];
  }, [allIds]);

  const goLast = useCallback(() => {
    if (allIds.length === 0) return null;
    const idx = allIds.length - 1;
    setCurrentIdx(idx);
    return allIds[idx];
  }, [allIds]);

  const goPrev = useCallback(() => {
    if (currentIdx <= 0) return null;
    const idx = currentIdx - 1;
    setCurrentIdx(idx);
    return allIds[idx];
  }, [allIds, currentIdx]);

  const goNext = useCallback(() => {
    if (currentIdx >= allIds.length - 1) return null;
    const idx = currentIdx + 1;
    setCurrentIdx(idx);
    return allIds[idx];
  }, [allIds, currentIdx]);

  return {
    allIds,
    currentIdx,
    hasPrev: currentIdx > 0,
    hasNext: currentIdx < allIds.length - 1,
    fetchList,
    setCurrentById,
    goFirst,
    goLast,
    goPrev,
    goNext,
  };
}
